(function () {
  function testimonialsSlide() {
    var sliders = document.querySelectorAll('.testimonials__slider');

    sliders.forEach(function (slider) {
      if (slider.getAttribute('data-initialized')) return;
      slider.setAttribute('data-initialized', 'true');

      var slides = slider.querySelectorAll('.testimonials__slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;

      var currentIndex = 0;

     function getSlidesToShow() {
  var containerWidth = slider.parentNode.offsetWidth;
  if (containerWidth < 750) return 1;
  if (totalSlides >= 3) return 3;
  return 2;
}

      function updateSlider() {
  var visible = getSlidesToShow();
  var maxIndex = Math.max(0, totalSlides - visible);
  if (currentIndex > maxIndex) currentIndex = maxIndex;

  for (var i = 0; i < slides.length; i++) {
    if (i >= currentIndex && i < currentIndex + visible) {
      slides[i].style.display = '';
    } else {
      slides[i].style.display = 'none';
    }
  }

  var testimonials = slider.parentNode;
  while (testimonials && !testimonials.classList.contains('testimonials')) {
    testimonials = testimonials.parentNode;
  }

  if (testimonials) {
    var countsEl = testimonials.querySelector('.testimonials__counts');
    if (countsEl) countsEl.textContent = (currentIndex + 1) + '/' + totalSlides;
  }
}

      var container = slider.parentNode;
      while (container && !container.classList.contains('testimonials')) {
        container = container.parentNode;
      }

      if (container) {
        var nextBtn = container.querySelector('.testimonials__button--next');
        var prevBtn = container.querySelector('.testimonials__button--prev');

        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            var visible = getSlidesToShow();
            var maxIndex = Math.max(0, totalSlides - visible);
            if (currentIndex < maxIndex) {
              currentIndex++;
              updateSlider();
            }
          });
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            if (currentIndex > 0) {
              currentIndex--;
              updateSlider();
            }
          });
        }
      }

      updateSlider();
      window.addEventListener('resize', updateSlider);
    });

    var readMoreBtns = document.querySelectorAll('.testimonials__slide-read-more');
    for (var i = 0; i < readMoreBtns.length; i++) {
      readMoreBtns[i].addEventListener('click', function () {
        var slide = this.parentNode;
        while (slide && !slide.classList.contains('testimonials__slide')) {
          slide = slide.parentNode;
        }
        if (slide) slide.classList.add('testimonials__slide--expanded');
      });
    }

    var readLessBtns = document.querySelectorAll('.testimonials__slide-read-less');
    for (var i = 0; i < readLessBtns.length; i++) {
      readLessBtns[i].addEventListener('click', function () {
        var slide = this.parentNode;
        while (slide && !slide.classList.contains('testimonials__slide')) {
          slide = slide.parentNode;
        }
        if (slide) slide.classList.remove('testimonials__slide--expanded');
      });
    }
  }

  document.addEventListener('shopify:section:load', testimonialsSlide);
 document.addEventListener('DOMContentLoaded', testimonialsSlide);
})();